export default __webpack_public_path__ + "static/media/Group -12-TataNeu.87c553a9.png";